import { render } from "./OurLatestProjects.vue?vue&type=template&id=02dc702e"
import script from "./OurLatestProjects.vue?vue&type=script&lang=js"
export * from "./OurLatestProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__